<!--
 * @Descripttion: 权限验证页面
 * @Author: chenjinsheng
 * @Date: 2021-08-02 11:09:06
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-08-03 11:18:14
-->
<template>
    <div class="page-author" />
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            ticket: "",
            redirect: "",
            token: "",
        };
    },
    created() {
        this.login();
    },
    methods: {
        login() {
            // 进入登录页面先清空个人信息
            this.ticket = this.$route.query.ticket;
            this.token = this.$route.query.token;
            this.redirect = this.$route.query.redirect;
            if (this.ticket) {
                this.doLoginByTicket();
            } else if (this.token) {
                this.doLoginByToken();
            } else if (this.$store.state.user.oauth) {
                this.goBeforeLoginUrl();
            } else {
                this.$store.dispatch("goLogin").then(() => {
                    this.goBeforeLoginUrl();
                });
            }
        },

        /**
         * @description: 账套登录
         * @param {*}
         * @return {*}
         */
        doLoginByTicket() {
            this.$store
                .dispatch("doLoginByTicket", {
                    ticket: this.ticket,
                    redirect: this.redirect,
                    domain: this.$config.baseURL,
                })
                .then(() => {
                    this.goBeforeLoginUrl();
                });
        },

        /**
         * @description: token登录
         * @param {*}
         * @return {*}
         */
        doLoginByToken() {
            this.$store.dispatch("doLoginByToken", this.token).then(() => {
                this.goBeforeLoginUrl();
            });
        },
    },
};
</script>

<style scoped>
.page-author {
    height: 100%;
}
</style>
